"use client";

import { useFormatter, useTranslations } from "next-intl";

interface PreviewBannerProps {
  expiresAt: Date;
}

export function PreviewBanner({ expiresAt }: PreviewBannerProps) {
  const t = useTranslations("pages.articles.preview");
  const format = useFormatter();

  const expiresAtLabel = format.dateTime(expiresAt, {
    dateStyle: "medium",
    timeStyle: "short",
  });

  return (
    <aside
      role="note"
      aria-label={t("banner", { expiresAt: expiresAtLabel })}
      className="rounded-md border border-amber-400/60 bg-amber-50 px-4 py-3 text-sm text-amber-900"
    >
      {t("banner", { expiresAt: expiresAtLabel })}
    </aside>
  );
}
